import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';

import { tooltipMessages, tooltipMessageTypes } from '../../../constants/Tooltip';

import './Tooltip.scss';

class Tooltip extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    offset: PropTypes.object,
    style: PropTypes.object,
    tipText: PropTypes.string,
    // callback to pass tooltip DOM ref to parent component.
    // The parent can then programmatically show/hide the tooltip
    tooltipRef: PropTypes.func,
  };

  render() {
    const { tipText, intl, style, offset, tooltipRef } = this.props;

    const t = intl.formatMessage;

    // If tooltip text has been translated, use translated string. Otherwise, default to given string.
    const text = tooltipMessageTypes[tipText] ? t(tooltipMessages[tipText]) : tipText;

    return (
      <div
        className='TooltipTarget a11y--hideOnParentFocus'
        data-tip={text}
        data-for={text}
        style={style}
        ref={tooltipRef}
        aria-label={text}
      >
        <span className='visuallyHidden'>{text}</span>
        <ReactTooltip
          id={text}
          offset={offset}
          class='Tooltip--customTheme'
          effect='solid'
          delayShow={250}
        />
      </div>
    );
  }
}

export default injectIntl(Tooltip);
